import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  /* Insert your favorite CSS code to style a button */
  color: #fff;
  background: #3c77e3;
  border: 1px solid #3c77e3;
  width: 350px;
  height: 50px;
`;

const SubirArchivo = props => {

  const hiddenFileInput = React.useRef(null);

  const handleClick = event => {
    hiddenFileInput.current.click();
  };
  const handleChange = event => {
    const fileUploaded = event.target.files[0];
    props.handleFile(fileUploaded);
  };
  return (
    <>
      <Button onClick={handleClick}>
        SUBIR UNA IMAGEN
      </Button>

      <input type="file"
             ref={hiddenFileInput}
             onChange={handleChange}
             style={{display:'none'}}
      />
    </>
  );
};

export default SubirArchivo;
